import { ReactNode } from 'react';
import Spinner from '@rio-cloud/rio-uikit/Spinner';

type LoadingPanelProps = {
  loading: boolean;
  children: ReactNode;
};

export const LoadingPanel = ({ loading, children }: LoadingPanelProps) => {
  return loading ? (
    <div
      className={
        'height-150 display-flex justify-content-center align-items-center text-size-16'
      }
    >
      <Spinner isDoubleSized />
    </div>
  ) : (
    <>{children}</>
  );
};
